import { useEffect, useMemo, useState } from 'react';

function safeParseJSON(value, fallback) {
    if (!value || value === 'undefined' || value === 'null') return fallback;
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
}

function readLS(key, fallback) {
    if (!key) return fallback;
    return safeParseJSON(localStorage.getItem(key), fallback);
}

function writeLS(key, value) {
    if (!key) return;
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch {
        // ignore quota/blocked
    }
}

export function useMRTState({ storageKey = 'mrt', initialState = {}, pageSizeDefault, pageIndexDefault, rowCountDefault } = {}) {
    const resolvedPageSizeDefault = pageSizeDefault ?? initialState?.pagination?.pageSize ?? 5;
    const resolvedPageIndexDefault = pageIndexDefault ?? initialState?.pagination?.pageIndex ?? 0;
    const resolvedRowCountDefault = rowCountDefault ?? initialState?.rowCount ?? 0;

    const keys = useMemo(() => {
        const base = storageKey || 'mrt';
        return {
            pagination: `${base}.pagination`,
            columnFilters: `${base}.columnFilters`,
            columnFilterFns: `${base}.columnFilterFns`,
            globalFilter: `${base}.globalFilter`,
            sorting: `${base}.sorting`,
            rowCount: `${base}.rowCount`,
        };
    }, [storageKey]);

    const [columnFilterFns, setColumnFilterFns] = useState(() => readLS(keys.columnFilterFns, {}));
    const [columnFilters, setColumnFilters] = useState(() => readLS(keys.columnFilters, []));
    const [globalFilter, setGlobalFilter] = useState(() => readLS(keys.globalFilter, ''));
    const [sorting, setSorting] = useState(() => readLS(keys.sorting, []));

    const [pagination, setPagination] = useState(() => {
        const savedPagination = readLS(keys.pagination, null);

        return {
            pageIndex: savedPagination?.pageIndex ?? resolvedPageIndexDefault,

            pageSize: savedPagination?.pageSize ?? resolvedPageSizeDefault,
        };
    });

    useEffect(() => writeLS(keys.pagination, pagination), [keys.pagination, pagination]);
    useEffect(() => writeLS(keys.columnFilterFns, columnFilterFns), [keys.columnFilterFns, columnFilterFns]);
    useEffect(() => writeLS(keys.columnFilters, columnFilters), [keys.columnFilters, columnFilters]);
    useEffect(() => writeLS(keys.globalFilter, globalFilter), [keys.globalFilter, globalFilter]);
    useEffect(() => writeLS(keys.sorting, sorting), [keys.sorting, sorting]);

    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);

    // devido a nova paginação tive que modificar o código rowCount = 0 pagina retorna para 1
    const [rowCount, setRowCount] = useState(() => readLS(keys.rowCount, resolvedRowCountDefault));

    useEffect(() => writeLS(keys.rowCount, rowCount), [keys.rowCount, rowCount]);

    return {
        columnFilterFns,
        setColumnFilterFns,
        setColumnFiltersMode: setColumnFilterFns,

        columnFilters,
        setColumnFilters,

        globalFilter,
        setGlobalFilter,

        sorting,
        setSorting,

        pagination,
        setPagination,

        isError,
        setIsError,

        isLoading,
        setIsLoading,

        isRefetching,
        setIsRefetching,

        rowCount,
        setRowCount,
    };
}
